// src/pages/Home.js
import React from 'react';
import Registro from '../Authentication/Registro.js'; 
function Home() {
  return (
    <div>
        <Registro/>
    </div>
  );
}

export default Home;